// Customer mobile app strings (app-user), flattened from the Claude Design handoff
// (strings.json) to `app.<group>.<key>`. The handoff carries demo copy (named
// businesses, areas, dates, prices): those entries are dropped or parameterised here
// — real values come from the API. `{brand}` is the app name from config (INF-1).
// Per-screen additions live beside this file as app-strings-<group>.ts. Both languages
// are spread into en.ts / bn.ts so parity is enforced by the MessageKey type (DR-16).
export const appEn = {
  'app.common.appName': '{brand}',
  'app.common.continue': 'Continue',
  'app.common.bookNow': 'Book now',
  'app.common.book': 'Book',
  'app.common.call': 'Call',
  'app.common.whatsapp': 'WhatsApp',
  'app.common.directions': 'Directions',
  'app.common.share': 'Share',
  'app.common.showPass': 'Show pass',
  'app.common.verified': 'Verified',
  'app.common.from': 'From',
  'app.common.sponsored': 'Sponsored',
  'app.common.instant': 'Instant confirm',
  'app.common.yourSerial': 'Your serial',
  'app.common.confirmed': 'Confirmed',
  'app.common.disclaimer': '{brand} does not process, hold, or guarantee direct payments.',
  'app.common.comingSoon': 'Coming soon',
  'app.common.copy': 'Copy',
  'app.common.or': 'or',
  'app.common.stay': 'Stay',
  'app.common.change': 'Change',
  'app.common.any': 'Any',
  'app.common.other': 'Other',
  'app.common.today': 'Today',
  'app.common.tomorrow': 'Tomorrow',
  'app.common.closed': 'Closed',
  'app.common.full': 'Full',
  'app.common.taken': 'Taken',
  'app.common.undo': 'Undo',
  'app.common.retry': 'Try again',
  'app.common.offline': 'No internet — showing saved info',
  'app.common.explore': 'Explore',
  'app.common.days.thu': 'Thu',
  'app.common.days.fri': 'Fri',
  'app.common.days.sat': 'Sat',
  'app.common.days.sun': 'Sun',
  'app.common.days.mon': 'Mon',
  'app.common.days.tue': 'Tue',
  'app.common.days.satCap': 'SAT',
  'app.common.days.octCap': 'OCT',
  'app.common.days.sepCap': 'SEP',
  'app.common.dayparts.morning': 'Morning',
  'app.common.dayparts.afternoon': 'Afternoon',
  'app.common.dayparts.evening': 'Evening',
  'app.common.dayparts.anyTime': 'Any time',
  'app.tabs.home': 'Home',
  'app.tabs.offers': 'Offers',
  'app.tabs.bookings': 'Bookings',
  'app.tabs.saved': 'Saved',
  'app.tabs.account': 'Account',
  'app.status.pending': 'Pending',
  'app.status.payment_verification': 'Verifying payment',
  'app.status.rejected': 'Proof rejected',
  'app.status.confirmed': 'Confirmed',
  'app.status.in_progress': 'Happening today',
  'app.status.completed': 'Completed',
  'app.status.no_show': 'No-show',
  'app.status.cancelled': 'Cancelled',
  'app.status.refunded': 'Refunded',
  'app.status.expired': 'Expired',
  'app.statusMessages.mPending': 'Waiting for the business to confirm',
  'app.statusMessages.mPv': 'The business is checking your payment, usually within 2 hours.',
  'app.statusMessages.mRejected': 'Your payment proof didn’t match. Send it again to keep your booking.',
  'app.statusMessages.mConfirmed': 'You’re all set. See you there.',
  'app.statusMessages.mCompleted': 'This visit is complete. How was it?',
  'app.statusMessages.mCancelled': 'This booking was cancelled.',
  'app.statusMessages.mRefunded': 'Refunded — settled directly by the business.',
  'app.statusMessages.mExpired': 'The payment window expired.',
  'app.timeline.tlBooked': 'Booked',
  'app.timeline.tlSent': 'Payment sent',
  'app.timeline.tlChecked': 'Payment checked',
  'app.timeline.tlConfirmed': 'Confirmed',
  'app.timeline.tlDone': 'Done',
  'app.timeline.tlNoMatch': 'Didn’t match',
  'app.timeline.tlWaiting': 'Waiting',
  'app.reasons.proofRejected.rTrx': 'TrxID does not match',
  'app.reasons.proofRejected.rMoney': 'Money not received',
  'app.reasons.proofRejected.rShort': 'Amount is short',
  'app.reasons.proofRejected.rOther': 'Other',
  'app.reasons.cancel.cPlans': 'Plans changed',
  'app.reasons.cancel.cMistake': 'Booked by mistake',
  'app.reasons.cancel.cReach': 'Couldn’t reach the business',
  'app.reasons.cancel.cOther': 'Other',
  'app.reasons.report.pPaid': 'I paid but it wasn’t accepted',
  'app.reasons.report.pComplaint': 'Complaint',
  'app.reasons.report.pRefund': 'I want a refund',
  'app.reasons.report.pNoService': 'I didn’t get the service',
  'app.categories.cDoctor': 'Doctor',
  'app.categories.cSalon': 'Salon & spa',
  'app.categories.cHotel': 'Hotel',
  'app.categories.cTurf': 'Turf & sports',
  'app.categories.cRest': 'Restaurant',
  'app.categories.cEvents': 'Events',
  'app.categories.cClinic': 'Clinic & tests',
  'app.categories.cMore': 'More',
  'app.categories.cVenue': 'Venue & hall',
  'app.categories.cClasses': 'Classes',
  'app.categories.cGym': 'Gym',
  'app.categories.cConsult': 'Consultation',
  'app.categories.cPhoto': 'Photo studio',
  'app.categories.cCowork': 'Co-working',
  'app.categories.cRentals': 'Rentals',
  'app.onboarding.language.title': 'Choose your language',
  'app.onboarding.language.bangla': 'বাংলা',
  'app.onboarding.language.banglaSub': 'Bangla',
  'app.onboarding.language.english': 'English',
  'app.onboarding.language.englishSub': 'ইংরেজি',
  'app.onboarding.language.note': 'You can change this anytime in Account.',
  'app.onboarding.location.nearTitle': 'See places near you',
  'app.onboarding.location.nearBody': 'We only use your location to sort doctors, salons and turfs by distance.',
  'app.onboarding.location.allowLoc': 'Allow location',
  'app.onboarding.location.chooseArea': 'Choose my area',
  'app.onboarding.area.division': 'Division',
  'app.onboarding.area.city': 'City',
  'app.onboarding.area.area': 'Area',
  'app.onboarding.area.pick': 'Pick one',
  'app.onboarding.area.searchArea': 'Search area',
  'app.home.greeting': 'Good morning, {name}',
  'app.home.searchPh': 'Search doctor, salon, hotel, turf…',
  'app.home.nextBooking': 'Your next booking',
  'app.home.whatNeed': 'What do you need?',
  'app.home.allCats': 'All categories',
  'app.home.offersNear': 'Offers near you',
  'app.home.seeAll': 'See all',
  'app.home.popular': 'Popular near you',
  'app.home.browseArea': 'Browse by area',
  'app.search.search': 'Search',
  'app.search.what': 'What',
  'app.search.where': 'Where',
  'app.search.when': 'When',
  'app.search.useMyLoc': 'Use my location',
  'app.search.filters': 'Filters',
  'app.search.fee': 'Fee',
  'app.search.list': 'List',
  'app.search.map': 'Map',
  'app.search.sortBy': 'Sort by',
  'app.search.topRated': 'Top rated',
  'app.search.lowestFee': 'Lowest fee',
  'app.search.minRating': 'Minimum rating',
  'app.search.availability': 'Availability',
  'app.search.reset': 'Reset',
  'app.search.emptyTitle': 'No results — try a nearby area',
  'app.search.searchNearby': 'Search nearby areas',
  'app.search.clearFilters': 'Clear filters',
  'app.business.yrsExp': 'yrs experience',
  'app.business.services': 'Services',
  'app.business.team': 'Team',
  'app.business.about': 'About',
  'app.business.chamber': 'Chamber',
  'app.business.payments': 'Payments accepted',
  'app.business.bkash': 'bKash',
  'app.business.payVenue': 'Pay at venue',
  'app.business.feeFrom': 'Fee from',
  'app.business.callToBook': 'This doctor takes bookings by phone or WhatsApp.',
  'app.business.paused': 'Bookings paused',
  'app.business.notify': 'Notify me when open',
  'app.booking.header.stService': 'Service',
  'app.booking.header.stDetails': 'Details',
  'app.booking.header.stTime': 'Time',
  'app.booking.header.stPay': 'Pay',
  'app.booking.header.total': 'Total',
  'app.booking.header.stepOf': 'Step {n} of 4',
  'app.booking.step1.chooseService': 'Choose a service',
  'app.booking.step1.preselected': 'Preselected from the service you tapped. You can change it here.',
  'app.booking.step2.whoFor': 'Who is the visit for?',
  'app.booking.step2.someoneElse': 'Booking for someone else?',
  'app.booking.step2.doctorNote': 'Only the doctor sees this. It helps them prepare.',
  'app.booking.step2.choosePro': 'Choose a professional',
  'app.booking.step2.anyPro': 'Any professional',
  'app.booking.step2.anyProSub': 'First one free at your time',
  'app.booking.step2.howMany': 'How many tickets?',
  'app.booking.step2.eventNote': 'Tickets are named. Bring an ID that matches.',
  'app.booking.step2.party': 'How many guests?',
  'app.booking.step2.contact': 'Contact',
  'app.booking.step2.yourName': 'Your name',
  'app.booking.step2.phoneLabel': 'Phone number',
  'app.booking.step3.pickDate': 'Pick a date',
  'app.booking.step3.pickChamber': 'Pick a chamber',
  'app.booking.step3.pickTime': 'Pick a time',
  'app.booking.step3.pickHours': 'Pick your hours',
  'app.booking.step3.pickNights': 'Pick your nights',
  'app.booking.step3.pickShow': 'Pick a show',
  'app.booking.step3.pickBlock': 'Pick a block',
  'app.booking.step3.yourSerialNumber': 'Your serial number',
  'app.booking.step3.free': 'Free',
  'app.booking.step3.peak': 'Peak',
  'app.booking.step3.yourPick': 'Your pick',
  'app.booking.step3.backToBack': 'Pick back-to-back hours',
  'app.booking.step3.holding': 'We’re holding this time for you',
  'app.booking.step3.timesUp': 'Time’s up. Pick a time again.',
  'app.booking.step3.timesUpBody': 'Your hold ran out, so the slot is open to others again.',
  'app.booking.step3.pickAgain': 'Pick a time again',
  'app.booking.step3.checkIn': 'Check-in',
  'app.booking.step3.checkOut': 'Check-out',
  'app.booking.step3.soldOut': 'Sold out',
  'app.booking.step3.noTimes': 'No times free on this day — try another date',
  'app.booking.step4.payAtVenue': 'Pay at the venue',
  'app.booking.step4.yourPhone': 'Your phone',
  'app.booking.step4.phoneWhy': 'We text the pass and updates to this number.',
  'app.booking.step4.sendCode': 'Send code',
  'app.booking.step4.otpLabel': 'Enter the 6-digit code',
  'app.booking.step4.resendIn': 'Resend in {m}:{ss}',
  'app.booking.step4.phoneVerified': 'Phone verified',
  'app.booking.step4.howPay': 'How will you pay?',
  'app.booking.step4.payDirect': 'Pay the business directly',
  'app.booking.step4.payVenue': 'Pay at the venue',
  'app.booking.step4.paySecure': 'Pay securely via {brand}',
  'app.booking.step4.paySecureSub': 'Card · bKash · Nagad, held until confirmed',
  'app.booking.step4.copyNumber': 'Copy number',
  'app.booking.step4.st3': 'Copy the TrxID from the SMS and paste it below',
  'app.booking.step4.trxId': 'TrxID',
  'app.booking.step4.trxPh': 'e.g. BKA7X92MT4',
  'app.booking.step4.addShot': 'Add a screenshot instead',
  'app.booking.step4.camGal': 'Camera or gallery',
  'app.booking.step4.confirmBooking': 'Confirm booking',
  'app.booking.step4.payNowShort': 'Pay now',
  'app.booking.leave.leaveTitle': 'Leave without booking?',
  'app.booking.leave.leaveBody': 'Your picks will be lost and the held time will be released.',
  'app.booking.leave.leave': 'Leave',
  'app.booking.pass.placed': 'Booking placed!',
  'app.booking.pass.fDate': 'Date',
  'app.booking.pass.fTime': 'Time',
  'app.booking.pass.fBy': 'Booked by',
  'app.booking.pass.fPaid': 'Paid now',
  'app.booking.pass.savedOffline': 'Saved on your phone. It opens without internet.',
  'app.booking.pass.whatNext': 'What happens next',
  'app.booking.pass.addCal': 'Add to calendar',
  'app.booking.pass.goBookings': 'Go to my bookings',
  'app.bookings.list.myBookings': 'My bookings',
  'app.bookings.list.upcoming': 'Upcoming',
  'app.bookings.list.payCheck': 'Payment check',
  'app.bookings.list.past': 'Past',
  'app.bookings.list.cancelledTab': 'Cancelled',
  'app.bookings.list.needsAction': 'Needs your action',
  'app.bookings.list.comingUp': 'Coming up',
  'app.bookings.list.beingChecked': 'Being checked',
  'app.bookings.list.sendAgain': 'Send proof again',
  'app.bookings.list.showPass': 'Show pass',
  'app.bookings.list.writeReview': 'Write a review',
  'app.bookings.list.bookAgain': 'Book again',
  'app.bookings.list.receipt': 'Receipt',
  'app.bookings.empty.eUpT': 'No upcoming bookings',
  'app.bookings.empty.eUpB': 'Book a doctor, salon, turf or a stay — it shows up here.',
  'app.bookings.empty.eCta': 'Find something to book',
  'app.bookings.empty.ePcT': 'Nothing to check',
  'app.bookings.empty.ePcB': 'All your payments are settled.',
  'app.bookings.empty.ePaT': 'No past visits yet',
  'app.bookings.empty.ePaB': 'Completed bookings are kept here for your records.',
  'app.bookings.empty.eCaT': 'No cancelled bookings',
  'app.bookings.empty.eCaB': 'Cancelled, refunded and expired bookings land here.',
  'app.bookings.detail.booking': 'Booking',
  'app.bookings.detail.payment': 'Payment',
  'app.bookings.detail.method': 'Method',
  'app.bookings.detail.amount': 'Amount',
  'app.bookings.detail.business': 'Business',
  'app.bookings.detail.rejectedBy': 'Marked by the business',
  'app.bookings.detail.heldWhile': 'Your slot stays held while you resend.',
  'app.bookings.detail.reschedule': 'Reschedule',
  'app.bookings.detail.cancelBooking': 'Cancel booking',
  'app.bookings.detail.report': 'Report a problem',
  'app.bookings.detail.fDate': 'Date',
  'app.bookings.detail.fTime': 'Time',
  'app.bookings.detail.fSerial': 'Serial',
  'app.bookings.detail.fFee': 'Fee',
  'app.bookings.detail.fService': 'Service',
  'app.bookings.detail.fPaid': 'Paid',
  'app.bookings.detail.fCheckIn': 'Check-in',
  'app.bookings.detail.fCheckOut': 'Check-out',
  'app.bookings.detail.fNights': 'Nights',
  'app.bookings.detail.qrConfirmed': 'Show this at the chamber. Your serial is called in order.',
  'app.bookings.cancelSheet.cancelTitle': 'Cancel this booking?',
  'app.bookings.cancelSheet.whyCancel': 'Why are you cancelling?',
  'app.bookings.cancelSheet.refundByBiz': 'Refunds are paid by the business directly.',
  'app.bookings.cancelSheet.keepBooking': 'Keep booking',
  'app.bookings.rescheduleSheet.reschedTitle': 'Reschedule',
  'app.bookings.rescheduleSheet.pickDate': 'Pick a new date',
  'app.bookings.rescheduleSheet.pickChamber': 'Pick a chamber',
  'app.bookings.rescheduleSheet.current': 'Current',
  'app.bookings.rescheduleSheet.now': 'Now',
  'app.bookings.rescheduleSheet.newSerial': 'New',
  'app.bookings.resubmitSheet.reasonGiven': 'Reason given',
  'app.bookings.resubmitSheet.resubHint': '10 characters, letters and numbers, from the bKash SMS.',
  'app.bookings.resubmitSheet.addShot': 'Add a screenshot instead',
  'app.bookings.resubmitSheet.camGal': 'Camera or gallery',
  'app.bookings.reportSheet.whatHappened': 'What happened?',
  'app.bookings.reportSheet.tellMore': 'Tell us more',
  'app.bookings.reportSheet.tellMorePh': 'What happened, and when?',
  'app.bookings.reportSheet.addPhoto': 'Add photo',
  'app.bookings.reportSheet.sendReport': 'Send report',
  'app.bookings.reportSheet.filedTitle': 'Report filed',
  'app.bookings.reportSheet.filedBody': '{brand} will review within 24–72 hours.',
  'app.bookings.reportSheet.caseNo': 'Case',
  'app.bookings.reportSheet.csFiled': 'Filed',
  'app.bookings.reportSheet.csReview': 'Under review',
  'app.bookings.reportSheet.csDecision': 'Decision',
  'app.bookings.reportSheet.csNow': 'Just now',
  'app.bookings.reportSheet.csSoon': '24–72 h',
  'app.bookings.reportSheet.filedNotify': 'We’ll notify you here and by SMS when there’s a decision.',
  'app.bookings.reportSheet.backToBooking': 'Back to booking',
  'app.notifications.notifications': 'Notifications',
  'app.notifications.markRead': 'Mark all read',
  'app.notifications.todayG': 'Today',
  'app.notifications.earlier': 'Earlier',
  'app.notifications.yesterday': 'Yesterday',
  'app.offers.nearMe': 'Near me',
  'app.offers.biggestDiscount': 'Biggest discount',
  'app.offers.endingSoon': 'Ending soon',
  'app.offers.category': 'Category',
  'app.offers.featured': 'Featured',
  'app.offers.allOffers': 'All offers',
  'app.offers.updatedNow': 'Updated just now',
  'app.offers.eOfT': 'No offers near you right now',
  'app.offers.eOfB': 'Try another area, or check back — new deals land most weeks.',
  'app.offers.eOfCta': 'Browse another area',
  'app.offers.errT': 'Couldn’t load offers',
  'app.offers.errB': 'Something went wrong on our side. Try again in a moment.',
  'app.offers.endsToday': 'Ends today',
  'app.offers.endsTomorrow': 'Ends tomorrow',
  'app.saved.favourites': 'Favourites',
  'app.saved.dealAlerts': 'Deal alerts',
  'app.saved.dealAlertsSub': 'Max 1 notification a day for saved offers',
  'app.saved.eSvT': 'Nothing saved yet',
  'app.saved.eSvB': 'Tap the heart on a business or the bookmark on an offer to keep it here.',
  'app.saved.eSvCta': 'Explore nearby',
  'app.saved.offlineSaved': 'You’re offline. Your saved list is kept on this phone.',
  'app.account.myReviews': 'My reviews',
  'app.account.myClaims': 'My problems & claims',
  'app.account.messages': 'Messages',
  'app.account.notifSettings': 'Notification settings',
  'app.account.language': 'Language',
  'app.account.theme': 'Theme',
  'app.account.helpFaq': 'Help & FAQ',
  'app.account.contact': 'Contact',
  'app.account.terms': 'Terms & privacy',
  'app.account.signOut': 'Sign out',
  'app.account.deactAcct': 'Deactivate account',
  'app.account.langVal': 'English',
  'app.account.themeLight': 'Light',
  'app.account.themeDark': 'Dark',
  'app.account.notificationSettings.nBooking': 'Booking messages',
  'app.account.notificationSettings.nBookingSub': 'Confirmations, payment checks, changes',
  'app.account.notificationSettings.nReminders': 'Reminders',
  'app.account.notificationSettings.nRemindersSub': 'Day before and 2 hours before',
  'app.account.notificationSettings.nReviews': 'Reviews & replies',
  'app.account.notificationSettings.nReviewsSub': 'When a business replies to you',
  'app.account.notificationSettings.nClaims': 'Claims & reports',
  'app.account.notificationSettings.nClaimsSub': 'Status changes and decisions',
  'app.account.notificationSettings.nOffers': 'Offers & deal alerts',
  'app.account.notificationSettings.nOffersSub': 'Max 1 a day, saved offers only',
  'app.account.notificationSettings.nLockNote': 'Booking messages keep at least one channel on. Turn another on before switching this off.',
  'app.account.notificationSettings.channels.sms': 'SMS',
  'app.account.notificationSettings.channels.email': 'Email',
  'app.account.notificationSettings.channels.push': 'Push',
  'app.account.notificationSettings.notifFoot': 'SMS goes to your verified number. Email is optional and only used if you’ve added one.',
  'app.account.signOutSheet.soTitle': 'Sign out?',
  'app.account.signOutSheet.soBody': 'Your bookings and passes stay on your account. Sign back in with the same number any time.',
  'app.account.deactivateSheet.deactTitle': 'Deactivate your account?',
  'app.account.deactivateSheet.deactBody': 'You can come back whenever you like.',
  'app.account.deactivateSheet.deactB1': 'Hiding your account from businesses isn’t available yet.',
  'app.account.deactivateSheet.deactB2': 'You’re signed out on this phone.',
  'app.account.deactivateSheet.deactB3': 'Your bookings and reviews are kept.',
  'app.account.deactivateSheet.deactB4': 'Sign in again any time with the same number.',
  'app.account.deactivateSheet.deactCta': 'Continue',
  'app.account.deactivateSheet.keep': 'Keep account',
  'app.account.deactivateSheet.reqLink': 'Want your account and data removed permanently? Request deletion',
  'app.account.deactivateSheet.dxReasonTitle': 'Why are you leaving?',
  'app.account.deactivateSheet.dxReasonBody': 'Optional. It helps us improve.',
  'app.account.deactivateSheet.dxR1': 'Taking a break',
  'app.account.deactivateSheet.dxR2': 'Too many notifications',
  'app.account.deactivateSheet.dxR3': 'Privacy concerns',
  'app.account.deactivateSheet.dxR4': 'Something else',
  'app.account.deactivateSheet.dxSkip': 'Skip',
  'app.account.deactivateSheet.dxOtpTitle': 'Confirm with a code',
  'app.account.deactivateSheet.dxBack': 'Back',
  'app.account.deactivateSheet.dxDeactGo': 'Confirm and sign out',
  'app.account.deactivateSheet.dxBlkTitle': 'Can’t deactivate yet',
  'app.account.deactivateSheet.dxBlkBody': 'Finish or cancel your upcoming bookings first.',
  'app.account.deactivateSheet.dxBlkCta': 'View bookings',
  'app.account.deactivateSheet.dxClose': 'Close',
  'app.account.deactivateSheet.dxRqTitle': 'Request permanent deletion',
  'app.account.deactivateSheet.dxRqBody': 'We’ll delete your account and personal data after a 30-day window.',
  'app.account.deactivateSheet.dxRqHeadRem': 'What we remove',
  'app.account.deactivateSheet.dxRq1': 'Your profile, name, email and photo',
  'app.account.deactivateSheet.dxRq2': 'Saved places, offers and preferences',
  'app.account.deactivateSheet.dxRq3': 'Your phone number is freed for others',
  'app.account.deactivateSheet.dxRqHeadKeep': 'What we must keep by law',
  'app.account.deactivateSheet.dxRq4': 'Booking and payment records',
  'app.account.deactivateSheet.dxRqHeadWin': '30-day window',
  'app.account.deactivateSheet.dxRq5': 'Sign in at any point in the next 30 days and the request is cancelled.',
  'app.account.deactivateSheet.dxRqCta': 'Send request',
  'app.account.deactivateSheet.dxRcTitle': 'Request received',
  'app.account.deactivateSheet.dxRcBody': 'We’ll remove your account and data in 30 days. You’re being signed out now.',
  'app.account.deactivateSheet.dxWbTitle': 'Welcome back',
  'app.account.deactivateSheet.dxWbBody': 'Your account is active again.',
  'app.account.deactivateSheet.dxWbNote': 'Your deletion request has been cancelled.',
  'app.account.deactivateSheet.dxWbCta': 'Continue',
  'app.toasts.bookingSaved': 'Booking saved',
  'app.toasts.numberCopied': 'Number copied',
  'app.toasts.unsaved': 'Removed {name} from saved',
  'app.toasts.reportFiled': 'Report filed',
} as const satisfies Record<string, string>;

export const appBn = {
  'app.common.appName': '{brand}',
  'app.common.continue': 'এগিয়ে যান',
  'app.common.bookNow': 'বুক করুন',
  'app.common.book': 'বুক',
  'app.common.call': 'কল',
  'app.common.whatsapp': 'হোয়াটসঅ্যাপ',
  'app.common.directions': 'পথ দেখুন',
  'app.common.share': 'শেয়ার',
  'app.common.showPass': 'পাস দেখুন',
  'app.common.verified': 'যাচাইকৃত',
  'app.common.from': 'শুরু',
  'app.common.sponsored': 'স্পনসরড',
  'app.common.instant': 'তাৎক্ষণিক নিশ্চিত',
  'app.common.yourSerial': 'আপনার সিরিয়াল',
  'app.common.confirmed': 'নিশ্চিত',
  'app.common.disclaimer': '{brand} সরাসরি পেমেন্ট প্রক্রিয়া করে না, ধরে রাখে না বা নিশ্চয়তা দেয় না।',
  'app.common.comingSoon': 'শীঘ্রই আসছে',
  'app.common.copy': 'কপি',
  'app.common.or': 'অথবা',
  'app.common.stay': 'থাকুন',
  'app.common.change': 'বদলান',
  'app.common.any': 'যেকোনো',
  'app.common.other': 'অন্যান্য',
  'app.common.today': 'আজ',
  'app.common.tomorrow': 'আগামীকাল',
  'app.common.closed': 'বন্ধ',
  'app.common.full': 'পূর্ণ',
  'app.common.taken': 'নেওয়া',
  'app.common.undo': 'ফিরিয়ে আনুন',
  'app.common.retry': 'আবার চেষ্টা করুন',
  'app.common.offline': 'ইন্টারনেট নেই — সেভ করা তথ্য দেখানো হচ্ছে',
  'app.common.explore': 'খুঁজে দেখুন',
  'app.common.days.thu': 'বৃহ',
  'app.common.days.fri': 'শুক্র',
  'app.common.days.sat': 'শনি',
  'app.common.days.sun': 'রবি',
  'app.common.days.mon': 'সোম',
  'app.common.days.tue': 'মঙ্গল',
  'app.common.days.satCap': 'শনি',
  'app.common.days.octCap': 'অক্টো',
  'app.common.days.sepCap': 'সেপ্টে',
  'app.common.dayparts.morning': 'সকাল',
  'app.common.dayparts.afternoon': 'দুপুর',
  'app.common.dayparts.evening': 'সন্ধ্যা',
  'app.common.dayparts.anyTime': 'যেকোনো সময়',
  'app.tabs.home': 'হোম',
  'app.tabs.offers': 'অফার',
  'app.tabs.bookings': 'বুকিং',
  'app.tabs.saved': 'সেভ করা',
  'app.tabs.account': 'অ্যাকাউন্ট',
  'app.status.pending': 'অপেক্ষায়',
  'app.status.payment_verification': 'পেমেন্ট যাচাই হচ্ছে',
  'app.status.rejected': 'প্রুফ বাতিল',
  'app.status.confirmed': 'নিশ্চিত',
  'app.status.in_progress': 'আজ চলছে',
  'app.status.completed': 'সম্পন্ন',
  'app.status.no_show': 'অনুপস্থিত',
  'app.status.cancelled': 'বাতিল',
  'app.status.refunded': 'রিফান্ডেড',
  'app.status.expired': 'মেয়াদোত্তীর্ণ',
  'app.statusMessages.mPending': 'ব্যবসার নিশ্চিতকরণের অপেক্ষায়',
  'app.statusMessages.mPv': 'ব্যবসা আপনার পেমেন্ট যাচাই করছে, সাধারণত ২ ঘণ্টার মধ্যে।',
  'app.statusMessages.mRejected': 'আপনার পেমেন্ট প্রুফ মেলেনি। বুকিং রাখতে আবার পাঠান।',
  'app.statusMessages.mConfirmed': 'সব ঠিক আছে। দেখা হবে।',
  'app.statusMessages.mCompleted': 'এই ভিজিট সম্পন্ন। কেমন ছিল?',
  'app.statusMessages.mCancelled': 'এই বুকিং বাতিল হয়েছে।',
  'app.statusMessages.mRefunded': 'ফেরত দেওয়া হয়েছে — ব্যবসা সরাসরি মিটিয়েছে।',
  'app.statusMessages.mExpired': 'পেমেন্টের সময়সীমা শেষ।',
  'app.timeline.tlBooked': 'বুক হয়েছে',
  'app.timeline.tlSent': 'পেমেন্ট পাঠানো',
  'app.timeline.tlChecked': 'পেমেন্ট যাচাই',
  'app.timeline.tlConfirmed': 'নিশ্চিত',
  'app.timeline.tlDone': 'সম্পন্ন',
  'app.timeline.tlNoMatch': 'মেলেনি',
  'app.timeline.tlWaiting': 'অপেক্ষায়',
  'app.reasons.proofRejected.rTrx': 'TrxID মেলেনি',
  'app.reasons.proofRejected.rMoney': 'টাকা পাইনি',
  'app.reasons.proofRejected.rShort': 'টাকা কম',
  'app.reasons.proofRejected.rOther': 'অন্যান্য',
  'app.reasons.cancel.cPlans': 'পরিকল্পনা বদলেছে',
  'app.reasons.cancel.cMistake': 'ভুল করে বুক করেছি',
  'app.reasons.cancel.cReach': 'ব্যবসার সাথে যোগাযোগ হয়নি',
  'app.reasons.cancel.cOther': 'অন্যান্য',
  'app.reasons.report.pPaid': 'টাকা দিয়েছি কিন্তু গ্রহণ করেনি',
  'app.reasons.report.pComplaint': 'অভিযোগ',
  'app.reasons.report.pRefund': 'ফেরত চাই',
  'app.reasons.report.pNoService': 'সার্ভিস পাইনি',
  'app.categories.cDoctor': 'ডাক্তার',
  'app.categories.cSalon': 'সেলুন ও স্পা',
  'app.categories.cHotel': 'হোটেল',
  'app.categories.cTurf': 'টার্ফ ও খেলা',
  'app.categories.cRest': 'রেস্টুরেন্ট',
  'app.categories.cEvents': 'ইভেন্ট',
  'app.categories.cClinic': 'ক্লিনিক ও টেস্ট',
  'app.categories.cMore': 'আরও',
  'app.categories.cVenue': 'ভেন্যু ও হল',
  'app.categories.cClasses': 'ক্লাস',
  'app.categories.cGym': 'জিম',
  'app.categories.cConsult': 'পরামর্শ',
  'app.categories.cPhoto': 'ফটো স্টুডিও',
  'app.categories.cCowork': 'কো-ওয়ার্কিং',
  'app.categories.cRentals': 'ভাড়া',
  'app.onboarding.language.title': 'ভাষা বেছে নিন',
  'app.onboarding.language.bangla': 'বাংলা',
  'app.onboarding.language.banglaSub': 'Bangla',
  'app.onboarding.language.english': 'English',
  'app.onboarding.language.englishSub': 'ইংরেজি',
  'app.onboarding.language.note': 'অ্যাকাউন্ট থেকে যেকোনো সময় বদলানো যাবে।',
  'app.onboarding.location.nearTitle': 'কাছের জায়গা দেখুন',
  'app.onboarding.location.nearBody': 'দূরত্ব অনুযায়ী ডাক্তার, সেলুন ও টার্ফ সাজাতে শুধু আপনার লোকেশন ব্যবহার করি।',
  'app.onboarding.location.allowLoc': 'লোকেশন অনুমতি দিন',
  'app.onboarding.location.chooseArea': 'আমার এলাকা বেছে নিন',
  'app.onboarding.area.division': 'বিভাগ',
  'app.onboarding.area.city': 'শহর',
  'app.onboarding.area.area': 'এলাকা',
  'app.onboarding.area.pick': 'বেছে নিন',
  'app.onboarding.area.searchArea': 'এলাকা খুঁজুন',
  'app.home.greeting': 'শুভ সকাল, {name}',
  'app.home.searchPh': 'ডাক্তার, সেলুন, হোটেল, টার্ফ খুঁজুন…',
  'app.home.nextBooking': 'আপনার পরবর্তী বুকিং',
  'app.home.whatNeed': 'কী দরকার?',
  'app.home.allCats': 'সব ক্যাটাগরি',
  'app.home.offersNear': 'কাছের অফার',
  'app.home.seeAll': 'সব দেখুন',
  'app.home.popular': 'কাছের জনপ্রিয়',
  'app.home.browseArea': 'এলাকা অনুযায়ী দেখুন',
  'app.search.search': 'খুঁজুন',
  'app.search.what': 'কী',
  'app.search.where': 'কোথায়',
  'app.search.when': 'কখন',
  'app.search.useMyLoc': 'আমার লোকেশন ব্যবহার করুন',
  'app.search.filters': 'ফিল্টার',
  'app.search.fee': 'ফি',
  'app.search.list': 'তালিকা',
  'app.search.map': 'ম্যাপ',
  'app.search.sortBy': 'সাজান',
  'app.search.topRated': 'সেরা রেটিং',
  'app.search.lowestFee': 'সর্বনিম্ন ফি',
  'app.search.minRating': 'ন্যূনতম রেটিং',
  'app.search.availability': 'সময়সূচি',
  'app.search.reset': 'রিসেট',
  'app.search.emptyTitle': 'কিছু পাওয়া যায়নি — কাছের এলাকা দেখুন',
  'app.search.searchNearby': 'কাছের এলাকায় খুঁজুন',
  'app.search.clearFilters': 'ফিল্টার মুছুন',
  'app.business.yrsExp': 'বছর অভিজ্ঞতা',
  'app.business.services': 'সেবা',
  'app.business.team': 'টিম',
  'app.business.about': 'সম্পর্কে',
  'app.business.chamber': 'চেম্বার',
  'app.business.payments': 'যেসব পেমেন্ট নেওয়া হয়',
  'app.business.bkash': 'বিকাশ',
  'app.business.payVenue': 'ভেন্যুতে পেমেন্ট',
  'app.business.feeFrom': 'ফি শুরু',
  'app.business.callToBook': 'এই ডাক্তার ফোন বা হোয়াটসঅ্যাপে বুকিং নেন।',
  'app.business.paused': 'বুকিং স্থগিত',
  'app.business.notify': 'খুললে আমাকে জানান',
  'app.booking.header.stService': 'সার্ভিস',
  'app.booking.header.stDetails': 'তথ্য',
  'app.booking.header.stTime': 'সময়',
  'app.booking.header.stPay': 'পেমেন্ট',
  'app.booking.header.total': 'মোট',
  'app.booking.header.stepOf': 'ধাপ {n}/৪',
  'app.booking.step1.chooseService': 'সার্ভিস বেছে নিন',
  'app.booking.step1.preselected': 'আপনি যে সার্ভিসে ট্যাপ করেছিলেন সেটি আগে থেকে বাছাই করা। এখানে বদলানো যাবে।',
  'app.booking.step2.whoFor': 'ভিজিটটি কার জন্য?',
  'app.booking.step2.someoneElse': 'অন্য কারো জন্য বুক করছেন?',
  'app.booking.step2.doctorNote': 'শুধু ডাক্তার এটি দেখবেন। প্রস্তুতিতে সাহায্য করে।',
  'app.booking.step2.choosePro': 'বিশেষজ্ঞ বেছে নিন',
  'app.booking.step2.anyPro': 'যেকোনো বিশেষজ্ঞ',
  'app.booking.step2.anyProSub': 'আপনার সময়ে যিনি ফ্রি',
  'app.booking.step2.howMany': 'কয়টি টিকিট?',
  'app.booking.step2.eventNote': 'টিকিটে নাম থাকে। মিলিয়ে একটি আইডি আনুন।',
  'app.booking.step2.party': 'কতজন অতিথি?',
  'app.booking.step2.contact': 'যোগাযোগ',
  'app.booking.step2.yourName': 'আপনার নাম',
  'app.booking.step2.phoneLabel': 'ফোন নম্বর',
  'app.booking.step3.pickDate': 'তারিখ বেছে নিন',
  'app.booking.step3.pickChamber': 'চেম্বার বেছে নিন',
  'app.booking.step3.pickTime': 'সময় বেছে নিন',
  'app.booking.step3.pickHours': 'ঘণ্টা বেছে নিন',
  'app.booking.step3.pickNights': 'রাত বেছে নিন',
  'app.booking.step3.pickShow': 'শো বেছে নিন',
  'app.booking.step3.pickBlock': 'ব্লক বেছে নিন',
  'app.booking.step3.yourSerialNumber': 'আপনার সিরিয়াল নম্বর',
  'app.booking.step3.free': 'ফ্রি',
  'app.booking.step3.peak': 'পিক',
  'app.booking.step3.yourPick': 'আপনার পছন্দ',
  'app.booking.step3.backToBack': 'পরপর ঘণ্টা বেছে নিন',
  'app.booking.step3.holding': 'সময়টি আপনার জন্য ধরে রাখা হয়েছে',
  'app.booking.step3.timesUp': 'সময় শেষ। আবার সময় বাছুন।',
  'app.booking.step3.timesUpBody': 'হোল্ডের সময় শেষ, তাই স্লটটি আবার অন্যদের জন্য খোলা।',
  'app.booking.step3.pickAgain': 'আবার সময় বাছুন',
  'app.booking.step3.checkIn': 'চেক-ইন',
  'app.booking.step3.checkOut': 'চেক-আউট',
  'app.booking.step3.soldOut': 'শেষ',
  'app.booking.step3.noTimes': 'এই দিনে কোনো সময় ফ্রি নেই — অন্য তারিখ দেখুন',
  'app.booking.step4.payAtVenue': 'ভেন্যুতে দিন',
  'app.booking.step4.yourPhone': 'আপনার ফোন',
  'app.booking.step4.phoneWhy': 'এই নম্বরে পাস ও আপডেট এসএমএস করি।',
  'app.booking.step4.sendCode': 'কোড পাঠান',
  'app.booking.step4.otpLabel': '৬ সংখ্যার কোড দিন',
  'app.booking.step4.resendIn': 'আবার পাঠান {m}:{ss}-এ',
  'app.booking.step4.phoneVerified': 'ফোন যাচাই হয়েছে',
  'app.booking.step4.howPay': 'কীভাবে পেমেন্ট করবেন?',
  'app.booking.step4.payDirect': 'সরাসরি ব্যবসাকে পেমেন্ট করুন',
  'app.booking.step4.payVenue': 'গিয়ে পেমেন্ট করুন',
  'app.booking.step4.paySecure': '{brand}-এর মাধ্যমে নিরাপদে পেমেন্ট',
  'app.booking.step4.paySecureSub': 'কার্ড · বিকাশ · নগদ, নিশ্চিত হওয়া পর্যন্ত ধরে রাখা',
  'app.booking.step4.copyNumber': 'নম্বর কপি করুন',
  'app.booking.step4.st3': 'এসএমএস থেকে TrxID কপি করে নিচে দিন',
  'app.booking.step4.trxId': 'TrxID',
  'app.booking.step4.trxPh': 'যেমন BKA7X92MT4',
  'app.booking.step4.addShot': 'বদলে স্ক্রিনশট দিন',
  'app.booking.step4.camGal': 'ক্যামেরা বা গ্যালারি',
  'app.booking.step4.confirmBooking': 'বুকিং নিশ্চিত করুন',
  'app.booking.step4.payNowShort': 'এখন দিন',
  'app.booking.leave.leaveTitle': 'বুক না করে চলে যাবেন?',
  'app.booking.leave.leaveBody': 'আপনার বাছাই মুছে যাবে এবং ধরে রাখা সময় ছেড়ে দেওয়া হবে।',
  'app.booking.leave.leave': 'চলে যান',
  'app.booking.pass.placed': 'বুকিং হয়েছে!',
  'app.booking.pass.fDate': 'তারিখ',
  'app.booking.pass.fTime': 'সময়',
  'app.booking.pass.fBy': 'বুক করেছেন',
  'app.booking.pass.fPaid': 'এখন দেওয়া',
  'app.booking.pass.savedOffline': 'আপনার ফোনে সেভ আছে। ইন্টারনেট ছাড়াই খোলে।',
  'app.booking.pass.whatNext': 'এরপর কী হবে',
  'app.booking.pass.addCal': 'ক্যালেন্ডারে যোগ করুন',
  'app.booking.pass.goBookings': 'আমার বুকিংয়ে যান',
  'app.bookings.list.myBookings': 'আমার বুকিং',
  'app.bookings.list.upcoming': 'আসন্ন',
  'app.bookings.list.payCheck': 'পেমেন্ট যাচাই',
  'app.bookings.list.past': 'আগের',
  'app.bookings.list.cancelledTab': 'বাতিল',
  'app.bookings.list.needsAction': 'আপনার পদক্ষেপ দরকার',
  'app.bookings.list.comingUp': 'সামনে আসছে',
  'app.bookings.list.beingChecked': 'যাচাই চলছে',
  'app.bookings.list.sendAgain': 'আবার প্রুফ পাঠান',
  'app.bookings.list.showPass': 'পাস দেখান',
  'app.bookings.list.writeReview': 'রিভিউ লিখুন',
  'app.bookings.list.bookAgain': 'আবার বুক করুন',
  'app.bookings.list.receipt': 'রসিদ',
  'app.bookings.empty.eUpT': 'কোনো আসন্ন বুকিং নেই',
  'app.bookings.empty.eUpB': 'ডাক্তার, সেলুন, টার্ফ বা থাকার জায়গা বুক করুন — এখানে দেখাবে।',
  'app.bookings.empty.eCta': 'বুক করার কিছু খুঁজুন',
  'app.bookings.empty.ePcT': 'যাচাইয়ের কিছু নেই',
  'app.bookings.empty.ePcB': 'আপনার সব পেমেন্ট মিটে গেছে।',
  'app.bookings.empty.ePaT': 'এখনো কোনো আগের ভিজিট নেই',
  'app.bookings.empty.ePaB': 'সম্পন্ন বুকিং আপনার রেকর্ডের জন্য এখানে থাকবে।',
  'app.bookings.empty.eCaT': 'কোনো বাতিল বুকিং নেই',
  'app.bookings.empty.eCaB': 'বাতিল, ফেরত ও মেয়াদোত্তীর্ণ বুকিং এখানে থাকে।',
  'app.bookings.detail.booking': 'বুকিং',
  'app.bookings.detail.payment': 'পেমেন্ট',
  'app.bookings.detail.method': 'মাধ্যম',
  'app.bookings.detail.amount': 'পরিমাণ',
  'app.bookings.detail.business': 'ব্যবসা',
  'app.bookings.detail.rejectedBy': 'ব্যবসা চিহ্নিত করেছে',
  'app.bookings.detail.heldWhile': 'আবার পাঠানোর সময় আপনার স্লট ধরে রাখা থাকে।',
  'app.bookings.detail.reschedule': 'সময় বদলান',
  'app.bookings.detail.cancelBooking': 'বুকিং বাতিল করুন',
  'app.bookings.detail.report': 'সমস্যা জানান',
  'app.bookings.detail.fDate': 'তারিখ',
  'app.bookings.detail.fTime': 'সময়',
  'app.bookings.detail.fSerial': 'সিরিয়াল',
  'app.bookings.detail.fFee': 'ফি',
  'app.bookings.detail.fService': 'সার্ভিস',
  'app.bookings.detail.fPaid': 'দেওয়া',
  'app.bookings.detail.fCheckIn': 'চেক-ইন',
  'app.bookings.detail.fCheckOut': 'চেক-আউট',
  'app.bookings.detail.fNights': 'রাত',
  'app.bookings.detail.qrConfirmed': 'চেম্বারে এটি দেখান। সিরিয়াল ক্রমানুসারে ডাকা হয়।',
  'app.bookings.cancelSheet.cancelTitle': 'এই বুকিং বাতিল করবেন?',
  'app.bookings.cancelSheet.whyCancel': 'কেন বাতিল করছেন?',
  'app.bookings.cancelSheet.refundByBiz': 'ফেরত ব্যবসা সরাসরি দেয়।',
  'app.bookings.cancelSheet.keepBooking': 'বুকিং রাখুন',
  'app.bookings.rescheduleSheet.reschedTitle': 'সময় বদলান',
  'app.bookings.rescheduleSheet.pickDate': 'নতুন তারিখ বেছে নিন',
  'app.bookings.rescheduleSheet.pickChamber': 'চেম্বার বেছে নিন',
  'app.bookings.rescheduleSheet.current': 'বর্তমান',
  'app.bookings.rescheduleSheet.now': 'এখন',
  'app.bookings.rescheduleSheet.newSerial': 'নতুন',
  'app.bookings.resubmitSheet.reasonGiven': 'কারণ',
  'app.bookings.resubmitSheet.resubHint': 'বিকাশ এসএমএস থেকে ১০ অক্ষরের আইডি।',
  'app.bookings.resubmitSheet.addShot': 'বদলে স্ক্রিনশট দিন',
  'app.bookings.resubmitSheet.camGal': 'ক্যামেরা বা গ্যালারি',
  'app.bookings.reportSheet.whatHappened': 'কী হয়েছে?',
  'app.bookings.reportSheet.tellMore': 'বিস্তারিত বলুন',
  'app.bookings.reportSheet.tellMorePh': 'কী হয়েছিল, কখন?',
  'app.bookings.reportSheet.addPhoto': 'ছবি দিন',
  'app.bookings.reportSheet.sendReport': 'রিপোর্ট পাঠান',
  'app.bookings.reportSheet.filedTitle': 'রিপোর্ট জমা হয়েছে',
  'app.bookings.reportSheet.filedBody': '{brand} ২৪–৭২ ঘণ্টার মধ্যে পর্যালোচনা করবে।',
  'app.bookings.reportSheet.caseNo': 'কেস',
  'app.bookings.reportSheet.csFiled': 'জমা',
  'app.bookings.reportSheet.csReview': 'পর্যালোচনায়',
  'app.bookings.reportSheet.csDecision': 'সিদ্ধান্ত',
  'app.bookings.reportSheet.csNow': 'এইমাত্র',
  'app.bookings.reportSheet.csSoon': '২৪–৭২ ঘণ্টা',
  'app.bookings.reportSheet.filedNotify': 'সিদ্ধান্ত হলে এখানে ও এসএমএসে জানাব।',
  'app.bookings.reportSheet.backToBooking': 'বুকিংয়ে ফিরুন',
  'app.notifications.notifications': 'নোটিফিকেশন',
  'app.notifications.markRead': 'সব পঠিত করুন',
  'app.notifications.todayG': 'আজ',
  'app.notifications.earlier': 'আগে',
  'app.notifications.yesterday': 'গতকাল',
  'app.offers.nearMe': 'কাছাকাছি',
  'app.offers.biggestDiscount': 'সবচেয়ে বেশি ছাড়',
  'app.offers.endingSoon': 'শেষ হচ্ছে',
  'app.offers.category': 'ক্যাটাগরি',
  'app.offers.featured': 'বাছাই করা',
  'app.offers.allOffers': 'সব অফার',
  'app.offers.updatedNow': 'এইমাত্র আপডেট',
  'app.offers.eOfT': 'এখন আপনার কাছে কোনো অফার নেই',
  'app.offers.eOfB': 'অন্য এলাকা দেখুন, বা পরে আসুন — প্রায় প্রতি সপ্তাহে নতুন অফার আসে।',
  'app.offers.eOfCta': 'অন্য এলাকা দেখুন',
  'app.offers.errT': 'অফার লোড হয়নি',
  'app.offers.errB': 'আমাদের দিকে একটা সমস্যা হয়েছে। একটু পরে আবার চেষ্টা করুন।',
  'app.offers.endsToday': 'আজ শেষ',
  'app.offers.endsTomorrow': 'আগামীকাল শেষ',
  'app.saved.favourites': 'পছন্দ',
  'app.saved.dealAlerts': 'অফার অ্যালার্ট',
  'app.saved.dealAlertsSub': 'সেভ করা অফারের জন্য দিনে সর্বোচ্চ ১টি নোটিফিকেশন',
  'app.saved.eSvT': 'এখনো কিছু সেভ করা নেই',
  'app.saved.eSvB': 'ব্যবসায় হার্ট বা অফারে বুকমার্ক চাপলে এখানে থাকবে।',
  'app.saved.eSvCta': 'কাছাকাছি দেখুন',
  'app.saved.offlineSaved': 'আপনি অফলাইনে। সেভ করা তালিকা এই ফোনে রাখা আছে।',
  'app.account.myReviews': 'আমার রিভিউ',
  'app.account.myClaims': 'আমার সমস্যা ও দাবি',
  'app.account.messages': 'মেসেজ',
  'app.account.notifSettings': 'নোটিফিকেশন সেটিংস',
  'app.account.language': 'ভাষা',
  'app.account.theme': 'থিম',
  'app.account.helpFaq': 'সাহায্য ও প্রশ্নোত্তর',
  'app.account.contact': 'যোগাযোগ',
  'app.account.terms': 'শর্তাবলী ও গোপনীয়তা',
  'app.account.signOut': 'সাইন আউট',
  'app.account.deactAcct': 'অ্যাকাউন্ট নিষ্ক্রিয় করুন',
  'app.account.langVal': 'বাংলা',
  'app.account.themeLight': 'লাইট',
  'app.account.themeDark': 'ডার্ক',
  'app.account.notificationSettings.nBooking': 'বুকিং মেসেজ',
  'app.account.notificationSettings.nBookingSub': 'নিশ্চিতকরণ, পেমেন্ট যাচাই, পরিবর্তন',
  'app.account.notificationSettings.nReminders': 'রিমাইন্ডার',
  'app.account.notificationSettings.nRemindersSub': 'আগের দিন ও ২ ঘণ্টা আগে',
  'app.account.notificationSettings.nReviews': 'রিভিউ ও উত্তর',
  'app.account.notificationSettings.nReviewsSub': 'ব্যবসা উত্তর দিলে',
  'app.account.notificationSettings.nClaims': 'দাবি ও রিপোর্ট',
  'app.account.notificationSettings.nClaimsSub': 'অবস্থা পরিবর্তন ও সিদ্ধান্ত',
  'app.account.notificationSettings.nOffers': 'অফার ও ডিল অ্যালার্ট',
  'app.account.notificationSettings.nOffersSub': 'দিনে সর্বোচ্চ ১টি, শুধু সেভ করা অফার',
  'app.account.notificationSettings.nLockNote': 'বুকিং মেসেজের অন্তত একটি মাধ্যম চালু থাকে। এটি বন্ধ করার আগে অন্যটি চালু করুন।',
  'app.account.notificationSettings.channels.sms': 'SMS',
  'app.account.notificationSettings.channels.email': 'ইমেইল',
  'app.account.notificationSettings.channels.push': 'পুশ',
  'app.account.notificationSettings.notifFoot': 'এসএমএস আপনার যাচাইকৃত নম্বরে যায়। ইমেইল ঐচ্ছিক, যোগ করলে তবেই ব্যবহার হয়।',
  'app.account.signOutSheet.soTitle': 'সাইন আউট করবেন?',
  'app.account.signOutSheet.soBody': 'আপনার বুকিং ও পাস অ্যাকাউন্টে থাকবে। একই নম্বরে যেকোনো সময় আবার সাইন ইন করুন।',
  'app.account.deactivateSheet.deactTitle': 'অ্যাকাউন্ট নিষ্ক্রিয় করবেন?',
  'app.account.deactivateSheet.deactBody': 'আপনি যখন খুশি ফিরে আসতে পারবেন।',
  'app.account.deactivateSheet.deactB1': 'ব্যবসার কাছ থেকে অ্যাকাউন্ট লুকানোর সুবিধা এখনো চালু হয়নি।',
  'app.account.deactivateSheet.deactB2': 'এই ফোনে আপনাকে সাইন আউট করা হবে।',
  'app.account.deactivateSheet.deactB3': 'আপনার বুকিং ও রিভিউ রাখা হবে।',
  'app.account.deactivateSheet.deactB4': 'একই নম্বরে যেকোনো সময় আবার সাইন ইন করুন।',
  'app.account.deactivateSheet.deactCta': 'এগিয়ে যান',
  'app.account.deactivateSheet.keep': 'অ্যাকাউন্ট রাখুন',
  'app.account.deactivateSheet.reqLink': 'অ্যাকাউন্ট ও তথ্য স্থায়ীভাবে মুছে ফেলতে চান? মুছে ফেলার অনুরোধ করুন',
  'app.account.deactivateSheet.dxReasonTitle': 'কেন চলে যাচ্ছেন?',
  'app.account.deactivateSheet.dxReasonBody': 'ঐচ্ছিক। এতে আমরা আরও ভালো করতে পারি।',
  'app.account.deactivateSheet.dxR1': 'কিছুদিন বিরতি নিচ্ছি',
  'app.account.deactivateSheet.dxR2': 'নোটিফিকেশন অনেক বেশি',
  'app.account.deactivateSheet.dxR3': 'গোপনীয়তা নিয়ে চিন্তা',
  'app.account.deactivateSheet.dxR4': 'অন্য কারণ',
  'app.account.deactivateSheet.dxSkip': 'এড়িয়ে যান',
  'app.account.deactivateSheet.dxOtpTitle': 'কোড দিয়ে নিশ্চিত করুন',
  'app.account.deactivateSheet.dxBack': 'পিছনে',
  'app.account.deactivateSheet.dxDeactGo': 'নিশ্চিত করে সাইন আউট',
  'app.account.deactivateSheet.dxBlkTitle': 'এখনই নিষ্ক্রিয় করা যাবে না',
  'app.account.deactivateSheet.dxBlkBody': 'আগে আপনার আসন্ন বুকিং শেষ করুন বা বাতিল করুন।',
  'app.account.deactivateSheet.dxBlkCta': 'বুকিং দেখুন',
  'app.account.deactivateSheet.dxClose': 'বন্ধ করুন',
  'app.account.deactivateSheet.dxRqTitle': 'স্থায়ীভাবে মুছে ফেলার অনুরোধ',
  'app.account.deactivateSheet.dxRqBody': '৩০ দিনের সময় পার হলে আমরা আপনার অ্যাকাউন্ট ও ব্যক্তিগত তথ্য মুছে ফেলব।',
  'app.account.deactivateSheet.dxRqHeadRem': 'যা মুছে ফেলা হবে',
  'app.account.deactivateSheet.dxRq1': 'আপনার প্রোফাইল, নাম, ইমেইল ও ছবি',
  'app.account.deactivateSheet.dxRq2': 'সেভ করা জায়গা, অফার ও পছন্দ',
  'app.account.deactivateSheet.dxRq3': 'আপনার ফোন নম্বর অন্যদের জন্য মুক্ত হবে',
  'app.account.deactivateSheet.dxRqHeadKeep': 'আইনত যা রাখতে হবে',
  'app.account.deactivateSheet.dxRq4': 'বুকিং ও পেমেন্ট রেকর্ড',
  'app.account.deactivateSheet.dxRqHeadWin': '৩০ দিনের সময়',
  'app.account.deactivateSheet.dxRq5': 'পরবর্তী ৩০ দিনের মধ্যে যেকোনো সময় সাইন ইন করলে অনুরোধ বাতিল হয়ে যাবে।',
  'app.account.deactivateSheet.dxRqCta': 'অনুরোধ পাঠান',
  'app.account.deactivateSheet.dxRcTitle': 'অনুরোধ পাওয়া গেছে',
  'app.account.deactivateSheet.dxRcBody': '৩০ দিনের মধ্যে আমরা আপনার অ্যাকাউন্ট ও তথ্য মুছে ফেলব। এখন আপনাকে সাইন আউট করা হচ্ছে।',
  'app.account.deactivateSheet.dxWbTitle': 'আবার স্বাগতম',
  'app.account.deactivateSheet.dxWbBody': 'আপনার অ্যাকাউন্ট আবার সক্রিয় হয়েছে।',
  'app.account.deactivateSheet.dxWbNote': 'আপনার মুছে ফেলার অনুরোধ বাতিল করা হয়েছে।',
  'app.account.deactivateSheet.dxWbCta': 'এগিয়ে যান',
  'app.toasts.bookingSaved': 'বুকিং সেভ হয়েছে',
  'app.toasts.numberCopied': 'নম্বর কপি হয়েছে',
  'app.toasts.unsaved': '{name} সেভ তালিকা থেকে সরানো হয়েছে',
  'app.toasts.reportFiled': 'রিপোর্ট জমা হয়েছে',
} as const satisfies Record<string, string>;
